export function uPlotCrashMarkersPlugin (getEvents) {
  return {
    hooks: {
      draw: u => {
        const events = getEvents()
        if (!events || events.length === 0) return

        const ctx = u.ctx
        const { left, top, width, height } = u.bbox

        const xScale = u.scales.x
        const xMin = xScale.min
        const xMax = xScale.max

        ctx.save()

        for (const event of events) {
          const ts = event.timestamp

          // Skip events outside the visible range
          if (ts < xMin || ts > xMax) continue

          // Convert timestamp to pixel x position
          const xPx = left + ((ts - xMin) / (xMax - xMin)) * width

          const isCrash = event.type === 'crash'

          // Draw vertical line
          ctx.beginPath()
          ctx.strokeStyle = isCrash ? 'rgba(231, 76, 60, 0.5)' : 'rgba(46, 204, 113, 0.4)'
          ctx.lineWidth = 1
          ctx.setLineDash([4, 4])
          ctx.moveTo(xPx, top)
          ctx.lineTo(xPx, top + height)
          ctx.stroke()
          ctx.setLineDash([])

          // Draw small label
          ctx.font = '9px "Open Sans", sans-serif'
          ctx.fillStyle = isCrash ? '#e74c3c' : '#2ecc71'

          const label = isCrash
            ? `\u25BC ${event.beforeCount}\u2192${event.afterCount}`
            : '\u2714 recovered'

          // Position text just to the right of the line, near the top
          const textX = xPx + 3
          const textY = top + 12

          ctx.fillText(label, textX, textY)
        }

        ctx.restore()
      }
    }
  }
}

export function uPlotTooltipPlugin (onHover) {
  let element

  return {
    hooks: {
      init: u => {
        element = u.root.querySelector('.over')

        element.onmouseenter = () => onHover()
        element.onmouseleave = () => onHover()
      },
      setCursor: u => {
        const { left, top, idx } = u.cursor

        if (idx === null) {
          onHover()
        } else {
          const bounds = element.getBoundingClientRect()

          onHover({
            left: bounds.left + left + window.pageXOffset,
            top: bounds.top + top + window.pageYOffset
          }, idx)
        }
      }
    }
  }
}
